import { onScopeDispose } from 'vue';

// Klein event-mechanisme om een Classic iframe terug naar zijn root-URL te
// laten springen wanneer in het menu op het al-actieve tabblad wordt geklikt.
// Nodig omdat diepe navigatie binnen het iframe de Vue-route ongemoeid laat,
// waardoor een normale route-wissel niet getriggerd wordt.
const listeners = new Set<() => void>();

export function useClassicEmbedReset() {
  function triggerReset() {
    listeners.forEach((listener) => listener());
  }

  function onReset(listener: () => void) {
    listeners.add(listener);
    onScopeDispose(() => listeners.delete(listener));
  }

  return { triggerReset, onReset };
}
